import { render, staticRenderFns } from "./SurveyAudience.vue?vue&type=template&id=4fa307e0"
import script from "./SurveyAudience.vue?vue&type=script&lang=js"
export * from "./SurveyAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports